module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/error-b374e5eabf4eecbd894cacc76d44224e.svg";